import { useTypedParams } from '@sorare/routing';

import { PrizePoolContenderPage } from 'pages/PrizePoolContenderPage';

import type { PageParams } from './__generated__/routeParams';

const PrizePoolContenderPageComponent = () => {
  const { leaderboard, contender } = useTypedParams<PageParams>();

  return (
    <PrizePoolContenderPage leaderboard={leaderboard} contender={contender} />
  );
};

export default PrizePoolContenderPageComponent;
